import { addClass } from '../tools/DOM';


export const init = () => {
	const element = document.querySelector('.header__logo-main');
	const sign = document.querySelector('.header__logo-sign');

	if (!element) return;

	const timeout = element.getAttribute('data-timeout') || 3000;

	const init = () => {
		addClass(element, 'is-hidden');

		if (sign) {
			addClass(sign, 'is-visible');
		}
	};


	setTimeout(init, timeout);
};



// WEBPACK FOOTER //
// ./src/js/components/logo.js